import PropTypes from 'prop-types';
import React, { useState } from 'react';

const HelloWorld = (props) => {
    console.log("Rendering HelloWorld", props);
    const [name, setName] = useState(props.name);

    return (
        <div>
            <h3>Hello, {name}!</h3>
            <hr />
            <form>
                <label htmlFor="name">
                    Say Hello to:
                    <input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </label>
            </form>
        </div>
    );
};


HelloWorld.propTypes = {
    name: PropTypes.string.isRequired,
};

export default HelloWorld;
